import Button, { ButtonVariants } from '@pixum/button';
import Text, { TEXT_VARIANT } from '@pixum/text';

type SuccessMessageProps = {
  constants: Record<string, string>;
  openInDialog?: boolean;
  onInstallClick?: () => void;
};

/**
 * Success message displayed after form submission.
 * Shows description from i18n constants.
 * When rendered in a dialog, displays installation guide button.
 */
export function SuccessMessage({ constants, openInDialog, onInstallClick }: SuccessMessageProps) {
  return (
    <>
      {constants.successDescription && (
        <Text variant={TEXT_VARIANT.BODY}>
          <span dangerouslySetInnerHTML={{ __html: constants.successDescription }} />
        </Text>
      )}
      {openInDialog && onInstallClick && (
        <Button
          label={constants.submitButtonHowToInstall}
          onClick={onInstallClick}
          variant={ButtonVariants.SECONDARY}
        >
          {constants.submitButtonHowToInstall}
        </Button>
      )}
    </>
  );
}
